import { useEffect, useState } from 'react';
import { caseService } from '@services/api/caseService';
import { telemetryService } from '@services/api/telemetryService';

export const Reports = () => {
  const [caseStats, setCaseStats] = useState<any>(null);
  const [errorStats, setErrorStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    const [casesResult, errorsResult] = await Promise.all([
      caseService.getCases({}),
      telemetryService.getErrorSummary('7d'),
    ]);

    if (casesResult.success && casesResult.data) {
      const cases = casesResult.data as any[];
      setCaseStats({
        total: cases.length,
        open: cases.filter((c: any) => c.status === 'open').length,
        closed: cases.filter((c: any) => c.status === 'closed').length,
        p1: cases.filter((c: any) => c.priority === 'p1').length,
        p2: cases.filter((c: any) => c.priority === 'p2').length,
        p3: cases.filter((c: any) => c.priority === 'p3').length,
      });
    }

    if (errorsResult.success && errorsResult.data) {
      setErrorStats(errorsResult.data);
    }

    setLoading(false);
  };

  return (
    <div>
      <h1 className="page-title">Reports & Analytics</h1>
      <p className="page-subtitle">Operational metrics and business intelligence</p>

      <div style={{ marginTop: 'var(--spacing-xxl)', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--spacing-lg)' }}>
        <div className="info-card">
          <h3 className="info-card-title">📋 Case Metrics</h3>
          {loading ? <p>Loading...</p> : (
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Total Cases</span>
                <span className="info-value">{caseStats?.total || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Open Cases</span>
                <span className="info-value">{caseStats?.open || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Closed Cases</span>
                <span className="info-value">{caseStats?.closed || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">High Priority (P1)</span>
                <span className="info-value">{caseStats?.p1 || 0}</span>
              </div>
            </div>
          )}
        </div>

        <div className="info-card">
          <h3 className="info-card-title">🚨 Error Metrics (7 Days)</h3>
          {loading ? <p>Loading...</p> : (
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Total Errors</span>
                <span className="info-value">{errorStats?.total_errors || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Unique Errors</span>
                <span className="info-value">{errorStats?.unique_errors || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Affected Users</span>
                <span className="info-value">{errorStats?.affected_users || 0}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

